import React from "react";

export const Footer = () => {
  return (
    <footer className="msd__footer ">
      <span className="sc-jNkFXo hzyXdA msd__footer__label--left">
        Powered by
        <a
          href="https://cleeng.com/who-are-cleeng"
          rel="noopener noreferrer"
          target="_blank"
          className="sc-ksXGtu hmEwVV"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="94"
            height="12"
            viewBox="0 0 193.217 24.755"
          >
            <g>
              <path
                d="M20.653 9.51a20.01 20.01 0 0 1 7.393 1c1.459.529 4.791 1.773 4.8 3.589.014 1.487-1.788 2.474-3.661 2.3-1.173-.114-2.088-.887-3.16-1.359-5.749-2.574-13.714.358-13.771 6.75a5.968 5.968 0 0 0 .572 2.66c1.216 2.817 4.419 5.12 8.823 5.091a10.827 10.827 0 0 0 4.161-.858c1.073-.458 2.074-1.387 3.446-1.5 1.673-.143 3.589.729 3.589 2.3 0 1.273-1.344 1.9-2.374 2.445a19.584 19.584 0 0 1-11.984 2c-5.148-.758-9.5-3.518-11.555-7.608-2.317-4.59-.415-9.4 2.145-12.055a15.6 15.6 0 0 1 4.876-3.232 19.873 19.873 0 0 1 6.7-1.523Z"
                transform="translate(-5.894 -9.47)"
                style={{ fill: "#65bd72" }}
              ></path>
              <path
                d="M214.322 9.695a3.344 3.344 0 0 1 3.089 1.645c.4 1.015.143 2.932.143 4.161v8.609c0 2.345-.343 4.619 1.359 5.377 1.416.629 5.177.215 7.179.215h3.661a9.8 9.8 0 0 1 3.446.215 2.443 2.443 0 0 1 1.716 2c.043 2.045-2.474 2.374-4.59 2.374H216.41c-2.36 0-4.6-.1-5.162-1.788-.386-1.158-.072-3.7-.072-5.305v-10.61c0-1.6-.215-4.147.143-5.162a3.077 3.077 0 0 1 3.003-1.731Z"
                transform="translate(-181.716 -9.654)"
                style={{ fill: "#65bd72" }}
              ></path>
              <path
                d="M399.755 9.477c6.75-.429 13.142 2.889 15.573 7.679.572 1.13 1.5 3.4 1 5.091-.758 2.588-6.807 1.788-10.468 1.788a12.967 12.967 0 0 1-3.8-.215 2.663 2.663 0 0 1-1.716-2 2.329 2.329 0 0 1 1.716-2.074c1.988-.787 5.877.829 5.877-2.074 0-1.33-1.487-2.031-2.445-2.517a9.832 9.832 0 0 0-3.8-1.073c-4.548-.358-8.18 1.816-9.61 4.733a7.082 7.082 0 0 0 .358 6.521 9.48 9.48 0 0 0 7.036 4.018c1.888.243 4.176.515 4.233 2.374.1 2.932-4.619 2.474-7.107 1.931-4.791-1.03-8.78-3.747-10.611-7.465a9.827 9.827 0 0 1-1-3.518c-.5-6.407 4.276-10.2 8.895-11.984a19.957 19.957 0 0 1 5.869-1.215Z"
                transform="translate(-330.741 -9.436)"
                style={{ fill: "#65bd77" }}
              ></path>
              <path
                d="M637.611 9.458c7.089-.458 13.213 3.032 15.573 7.679.586 1.144 1.5 3.418 1 5.091-.686 2.331-4.462 1.788-7.894 1.788-2.288 0-5.005.329-6.378-.215a2.694 2.694 0 0 1-1.716-2 2.469 2.469 0 0 1 1.931-2.145 31.055 31.055 0 0 1 3.732-.143c1.23-.114 1.931-.715 1.931-1.859 0-1.416-1.816-2.288-3.089-2.8-5.048-2.031-10.9.072-12.77 3.875a7.48 7.48 0 0 0-.215 5.591 9.124 9.124 0 0 0 5.091 4.519c2.717.958 6.678.215 6.75 2.874a2.451 2.451 0 0 1-1.645 2.074c-1.773.729-4.5.1-6.306-.358-5.22-1.316-10.325-5.177-10.754-10.754a9.678 9.678 0 0 1 1.073-5.52 13.333 13.333 0 0 1 5.305-5.305 18.649 18.649 0 0 1 8.381-2.392Z"
                transform="translate(-534.59 -9.418)"
                style={{ fill: "#66bd87" }}
              ></path>
              <path
                d="M870.8 10.077a5.436 5.436 0 0 1 1.788.143c1.745.558 3.3 2.36 4.733 3.518 3.818 3.089 7.436 5.892 11.412 9.038.787.629 1.516 1.573 2.517 1.573 2.646 0 1.931-4.1 1.931-6.821 0-1.9-.358-4.419.071-5.734.8-2.46 5.606-2.088 6.235.072.4 1.387.071 3.7.071 5.234v10.61c0 1.544.343 3.89-.071 5.162-.4 1.23-2.417 2.188-4.3 1.645-1.559-.443-3.5-2.531-4.733-3.518-3.79-3.046-7.579-6.006-11.483-9.109-.729-.572-1.673-1.587-2.517-1.573-2.617.029-1.931 3.775-1.931 6.821 0 1.916.286 4.347-.143 5.663-.686 2.116-5.134 2.6-6.092.143-.429-1.1-.143-3.532-.143-5.234V16.956c0-1.616-.229-4.033.143-5.162a2.79 2.79 0 0 1 2.512-1.717Z"
                transform="translate(-744.756 -9.965)"
                style={{ fill: "#63bc97" }}
              ></path>
              <path
                d="M1151.706 10.006a19.881 19.881 0 0 1 6.449.715c1.444.415 4.3 1.087 4.376 2.8.072 1.659-1.959 2.5-3.589 2.445a11.486 11.486 0 0 1-2.8-.858c-4.991-1.6-10.425.6-12.127 4.519a7.453 7.453 0 0 0 .143 5.663c1.8 3.647 7.493 5.949 12.7 3.947 1.373-.529 3.16-1.487 3.16-2.874 0-2.889-3.875-1.287-5.877-2.074a2.386 2.386 0 0 1-1.716-2 2.329 2.329 0 0 1 1.645-2 10.5 10.5 0 0 1 3.875-.286c3.418 0 9.7-.858 10.468 1.788a7.007 7.007 0 0 1-.286 3.089 11.72 11.72 0 0 1-4.3 6.163 17.072 17.072 0 0 1-10.325 3.589 18.366 18.366 0 0 1-10.9-3.017c-2.588-1.745-5.22-4.462-5.52-8.394-.358-4.576 1.916-7.45 4.376-9.467a18.55 18.55 0 0 1 10.248-3.748Z"
                transform="translate(-975.282 -9.894)"
                style={{ fill: "#64bca3" }}
              ></path>
            </g>
          </svg>
        </a>
      </span>
      <div className="sc-kNnbXp igWbKc msd__footer__label--right">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="13"
          viewBox="0 0 92.72 114.87"
        >
          <path
            d="M86.78 49.82c.43-2.44.66-4.95.66-7.52 0-23.33-18.43-42.31-41.08-42.31S5.28 18.98 5.28 42.31c0 2.57.24 5.07.66 7.52C2.37 52.11 0 56.09 0 60.64v41.42c0 7.08 5.74 12.83 12.82 12.83h67.07c7.08 0 12.82-5.74 12.82-12.83V60.63c0-4.55-2.37-8.53-5.94-10.81ZM52.02 85.98v9c0 3.13-2.53 5.66-5.66 5.66s-5.66-2.53-5.66-5.66v-9c-3.63-2-6.09-5.86-6.09-10.3 0-6.49 5.26-11.76 11.76-11.76s11.76 5.26 11.76 11.76c0 4.44-2.47 8.31-6.1 10.31ZM71.81 47.8h-50.9c-.35-1.78-.53-3.62-.53-5.5 0-15 11.66-27.21 25.99-27.21s25.98 12.2 25.98 27.21c0 1.88-.18 3.72-.53 5.5Z"
            style={{ fill: "#5db98f" }}
          ></path>
        </svg>
        Secured checkout
      </div>
    </footer>
  );
};
